import {createSelector} from 'reselect';
import {IBannerData} from './types';

export const smartEngageStateSelector = state => state.smartEngage;

export const smartEngageSelector = createSelector(smartEngageStateSelector, item => {
  const retVal = {
    isLoading: item.isLoading,
    dataList: [],
  };

  if (item && item.data && item.data) {
    const {slots} = item.data;

    const {dwebHotels_banner_srp = []} = slots;
    // Object.keys(slots).map(itemKey =>
    //   slots[itemKey].map((slotItem: IBannerData) => {
    //     listOfImages.push({image: slotItem.img_url, ctaUrl: slotItem.cta_url});
    //   }),
    // );

    const listOfImages = dwebHotels_banner_srp.map((slotItem: IBannerData) => ({
      image: slotItem?.img_url || '',
      ctaUrl: slotItem?.cta_url || '',
      filter: slotItem?.filter,
    }));

    retVal.dataList = listOfImages;
  }

  return retVal;
});

export const safetyHeaderDataSelectorFn = createSelector(smartEngageStateSelector, item => {
  let headerData = null;
  if (item && item.data && item.data.slots) {
    const {slots} = item.data;
    const {
      dwebHotels_info_home = [],
      dwebHotels_info_srp = [],
      dwebHotels_info_details = [],
    } = slots;
    const allData = [...dwebHotels_info_home, ...dwebHotels_info_srp, ...dwebHotels_info_details];
    if (allData.length) headerData = allData[0];
  }
  return {headerData, isLoading: item.isLoading};
});

export const homeBannerDataSelector = createSelector(smartEngageStateSelector, item => {
  let listOfImages = [];
  if (item && item.data && item.data.slots) {
    const {slots} = item.data;
    const {dwebHotels_banner_home = []} = slots;

    listOfImages = dwebHotels_banner_home.map((slotItem: IBannerData) => ({
      image: slotItem?.img_url || '',
      ctaUrl: slotItem?.cta_url || '',
      filter: slotItem?.filter,
    }));
  }

  return listOfImages;
});

export const smartEngageLoadingStatusSelector = createSelector(
  smartEngageStateSelector,
  item => item.isLoading,
);
